(function() {
  'use strict';

  function Cards(Sidebar) {
    var service = {};

    service.register = function() {
      var cards = [
        {
          id: 'placeholders',
          title: 'Placeholders',
          directive: 'sidebar-placeholders',
          options: {
            routes: [
              'epf.email-templates.template'
            ],
            paths: [
              'emails/:emailTypeId/:emailTemplateId'
            ]
          }
        }
      ];

      Sidebar.registerCards(cards);
    };

    return service;
  }

  Cards.$inject = ['SidebarService'];

  angular.module('component.emailTemplates')
    .service('EmailTemplatesCards', Cards);
})();
